import { Sparkles, Facebook, Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border/70 py-12" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-2.5">
          <span className="w-8 h-8 rounded-full bg-foam flex items-center justify-center text-pine">
            <Sparkles size={14} strokeWidth={1.75} />
          </span>
          <span className="font-display font-medium tracking-tight">
            Sparkling <span className="font-editorial italic font-semibold text-seateal">Ambitions</span>
          </span>
        </div>

        <p className="font-editorial italic text-lg text-pine/50" data-testid="footer-tagline">
          Clean Spaces. Happy Places.
        </p>

        <div className="flex items-center gap-3">
          <a
            href="https://www.facebook.com/share/1DV95SthrX/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Sparkling Ambitions on Facebook"
            className="w-10 h-10 rounded-full border border-pine/15 flex items-center justify-center text-pine/70 hover:bg-foam hover:text-pine hover:border-foam transition-colors duration-300"
            data-testid="footer-facebook-link"
          >
            <Facebook size={15} strokeWidth={1.75} />
          </a>
          <a
            href="https://www.instagram.com/sparklingambitionsknox"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Sparkling Ambitions on Instagram"
            className="w-10 h-10 rounded-full border border-pine/15 flex items-center justify-center text-pine/70 hover:bg-foam hover:text-pine hover:border-foam transition-colors duration-300"
            data-testid="footer-instagram-link"
          >
            <Instagram size={15} strokeWidth={1.75} />
          </a>
          <a
            href="mailto:sparkling.ambitions@icloud.com"
            aria-label="Email Sparkling Ambitions"
            className="w-10 h-10 rounded-full border border-pine/15 flex items-center justify-center text-pine/70 hover:bg-foam hover:text-pine hover:border-foam transition-colors duration-300"
            data-testid="footer-email-link"
          >
            <Mail size={15} strokeWidth={1.75} />
          </a>
        </div>
      </div>
      <p className="mt-8 text-center text-xs font-light text-pine/40" data-testid="footer-copyright">
        © {new Date().getFullYear()} Sparkling Ambitions Cleaning Co. · Knoxville, TN
      </p>
    </footer>
  );
}
